import React from "react";
import imageOverlay from "../img/test.PNG";
import { AiFillBehanceCircle as Behance } from "react-icons/ai";

class Contact extends React.Component {
  render() {
    return (
     <section
        className="paralax-mf footer-paralax bg-image sect-mt4 route"
        style={{ backgroundImage: "url(" + imageOverlay + ")" }}
      >
        <div className="overlay-mf"></div>
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="contact-mf">
                <div id="contact" className="box-shadow-full">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="title-box-2 pt-4 pt-md-0">
                        <h5 className="title-left">CONTACTOS</h5>
                      </div>
                      <div className="more-info">
                        {<ul class="list-ico">
                          <li><span class="ion-email"></span> joaofidalgo.photo@gmail.com</li>
                        </ul>}
                      </div>
                      <div className="socials">
                        <ul>
                          <li>
                            <a
                              href="https://www.behance.net/fidalgocin7626"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <span className="ico-circle">
                                <i className=""><Behance /></i>
                              </span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="copyright-box">
                </div>
              </div>
            </div>
          </div>
        </footer>
      </section>
    );
  }
}

export default Contact;
